import jscookie from 'js-cookie'
import { useRouter } from 'next/router'
import { SignUpForm } from 'ui-components'

import { devOnly } from 'user-auth/helpers/devOnly'
import { useAuthMetadata, useFederatedAuth } from 'user-auth/hooks'
import { useAtom } from 'user-auth/libs/jotai'
import { atoms } from 'user-auth/states/form'

import { CreateAccountForm } from './CreateAccountForm'
import { EmailPasswordConfirmForm } from './EmailPasswordConfirmForm'
import { EmailPasswordForm } from './EmailPasswordForm'
import { Header } from './Header'
import { UsernameForm } from './UsernameForm'

export function Form(props) {
  const [form] = useAtom(atoms.form.signUp)
  return (
    <>
      {form === 'default' ? <DefaultForm {...props} /> : null}
      {form === 'createAccount' ? <CreateAccountForm {...props} /> : null}
      {/* for developer */}
      {form === 'emailPassword' ? <EmailPasswordForm {...props} /> : null}
      {form === 'emailPasswordConfirm' ? (
        <EmailPasswordConfirmForm {...props} />
      ) : null}
    </>
  )
}

export function DefaultForm(props) {
  const { slotProps } = props

  const [, setForm] = useAtom(atoms.form.signUp)

  const router = useRouter()

  const { signIn } = useFederatedAuth()
  const { redirect } = useAuthMetadata()

  const callback = router.query?.callback
  const disabled = callback === 'true'

  const clearAuthCookie = () => {
    jscookie.remove('auth_metadata')
  }

  const handleGoogleClick = () => {
    clearAuthCookie()
    signIn({ provider: 'Google', redirect })
  }

  const handleFacebookClick = () => {
    clearAuthCookie()
    signIn({ provider: 'Facebook', redirect })
  }

  const handleEmailClick = () => {
    setForm('emailPassword')
  }

  return (
    <SignUpForm
      dev={devOnly(process.env.NEXT_PUBLIC_DOMAIN_NAME)}
      slots={{ Header, UsernameForm }}
      slotProps={{
        Header: slotProps?.Header,
        UsernameForm: slotProps?.UsernameForm,
        GoogleButton: {
          disabled,
          onClick: handleGoogleClick
        },
        FacebookButton: {
          disabled,
          onClick: handleFacebookClick
        },
        EmailButton: {
          disabled,
          onClick: handleEmailClick
        }
      }}
    />
  )
}
